import React from 'react';
import Button from '@mui/material/Button';
import { useLocale, useSetLocale } from "react-admin";

const LocaleSwitcher = () => {
    const setLocale = useSetLocale();
    const Locale = useLocale();
        
    const switchToWelsh = () => setLocale('cy');
    const switchToEnglish = () => setLocale('en');

    return (
        <div>
            <Button onClick={switchToEnglish} color='inherit'>View in English</Button>
            <Button onClick={switchToWelsh} color='inherit'>View yn Gymraeg</Button>
        </div>
    );
}

export default LocaleSwitcher;